import { ExperienceSurveyModal } from '@ltvco/refresh-lib/v2';
import { useEffect, useState } from 'react';

import { useTrustpilotLoginPrompt } from 'hooks/useTrustpilotLoginPrompt';

export function TrustpilotLoginPromptGate() {
  const { shouldShowPrompt, markPromptComplete } = useTrustpilotLoginPrompt();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (shouldShowPrompt) {
      setIsModalOpen(true);
    }
  }, [shouldShowPrompt]);

  if (!isModalOpen) return null;

  return (
    <ExperienceSurveyModal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      onLeaveReview={markPromptComplete}
      onLowRatingSubmit={markPromptComplete}
    />
  );
}
